// eslint-disable-next-line no-undef
/* eslint-disable no-restricted-globals */
import axios from 'axios'

const getSavedPdfs = ( data ) => {
  return axios.get( `${process.env.REACT_APP_API_PDF_URL}/pdf`, {
    params: {
      userId: data.userId,
      notdownloaded: true
    }
  } )
}

const exportPdf = ( data ) => {
  return axios.post( `${process.env.REACT_APP_API_PDF_URL}/pdf`, data )
}

const updatePdfVisuzalized = ( id ) => {
  return axios.put( `${process.env.REACT_APP_API_PDF_URL}/pdf/${id}` )
}

// eslint-disable-next-line no-restricted-globals
self.addEventListener( 'message', ( { data } ) => {
  const { type } = data
  if( type === 'save' ){ 
    exportPdf( data )
      .then( res => {
        self.postMessage( res.data )
      } )
  } else if( type === 'get' ) {
    getSavedPdfs( data ).then( res =>{
      self.postMessage( res.data )
    } )
  } else if ( type === 'put' ) {
    updatePdfVisuzalized( data.id ).then( res => {
      self.postMessage( res.data )
    } )
  }
} )


// WEBPACK FOOTER //
// ./src/workers/savePdf.worker.js